/**
 * Expands/collapses clamped content. Shows a toggle only when text is truncated.
 */
class ExpandableContent extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-expandable-content]');
    this.button = this.querySelector('[data-expandable-button]');

    if (!this.content || !this.button) return;

    this.expandLabel = this.button.dataset.expandLabel || 'More';
    this.collapseLabel = this.button.dataset.collapseLabel || 'Less';

    this.button.addEventListener('click', this.toggle.bind(this));
    this.updateButtonVisibility();

    this.resizeObserver = new ResizeObserver(() => this.updateButtonVisibility());
    this.resizeObserver.observe(this.content);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  toggle() {
    const isOpen = this.toggleAttribute('open');
    this.content.classList.toggle('line-clamp', !isOpen);
    this.button.textContent = isOpen ? this.collapseLabel : this.expandLabel;
    this.button.setAttribute('aria-expanded', String(isOpen));

    if (!isOpen) {
      this.updateButtonVisibility();
    }
  }

  updateButtonVisibility() {
    if (this.hasAttribute('open')) return;

    const truncated = this.content.scrollHeight > this.content.clientHeight + 1;
    this.button.hidden = !truncated;
  }
}

if (!window.customElements.get('expandable-content')) {
  window.customElements.define('expandable-content', ExpandableContent);
}
